import { render, staticRenderFns } from "./UploadImg.vue?vue&type=template&id=60411f95&scoped=true"
import script from "./UploadImg.vue?vue&type=script&lang=js"
export * from "./UploadImg.vue?vue&type=script&lang=js"
import style0 from "./UploadImg.vue?vue&type=style&index=0&id=60411f95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60411f95",
  null
  
)

export default component.exports